(() => {
  const sizes = ['XXXXS', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'ONE SIZE'];
  const cups = ['AAA', 'AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H'];
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
  const label = (node) => node.textContent.trim().toUpperCase().replace(/\s+/g, ' ').replace(/^([2-4])X([SL])$/, (_, n, end) => 'X'.repeat(Number(n)) + end);
  function compare(a, b) {
    const left = label(a), right = label(b), li = sizes.indexOf(left), ri = sizes.indexOf(right);
    if (li >= 0 && ri >= 0) return li - ri;
    const lb = left.match(/^(\d+)\s*[/ -]\s*([A-Z]+)$/), rb = right.match(/^(\d+)\s*[/ -]\s*([A-Z]+)$/);
    if (lb && rb) return Number(lb[1]) - Number(rb[1]) || (cups.indexOf(lb[2]) - cups.indexOf(rb[2])) || collator.compare(left, right);
    return collator.compare(left, right);
  }
  function arrange(list, nodes, paired = false) {
    if (!list || !nodes.length || list.dataset.mrSized) return;
    list.dataset.mrSized = 'true';
    nodes.sort(compare).forEach((node) => {
      if (paired && node.control) list.append(node.control);
      list.append(node);
    });
    const cupNames = nodes.map(label).map((text) => text.match(/^\d+\s*[/ -]\s*([A-Z]+)$/)?.[1]);
    const cupCount = cupNames.every(Boolean) ? new Set(cupNames).size : 0;
    const count = nodes.length;
    const small = cupCount || (count === 4 ? 2 : Math.min(count, 3));
    const large = cupCount || (count <= 6 ? count : Math.ceil(count / 2));
    list.style.setProperty('--mr-size-columns-small', Math.max(1, small));
    list.style.setProperty('--mr-size-columns-large', Math.max(1, large));
  }
  function normalizeModal(modal) {
    modal.querySelectorAll('.variant-picker__option-values').forEach((list) => {
      arrange(list, Array.from(list.querySelectorAll(':scope > label.block-swatch')), true);
    });
  }
  const observers = new WeakMap();
  document.addEventListener('dialog:before-show', (event) => {
    const modal = event.target;
    if (!modal.matches?.('quick-buy-modal')) return;
    closeAll();
    document.querySelectorAll('quick-buy-modal[open]').forEach((other) => {
      if (other === modal) return;
      other.focusTrap?.deactivate({ returnFocus: false });
      other.hide();
    });
    normalizeModal(modal);
    observers.get(modal)?.disconnect();
    const observer = new MutationObserver(() => normalizeModal(modal));
    observer.observe(modal, { childList: true, subtree: true });
    observers.set(modal, observer);
  }, { capture: true });
  document.addEventListener('dialog:after-hide', (event) => observers.get(event.target)?.disconnect(), { capture: true });

  function setOpen(card, open) {
    const panel = card?.querySelector('.product-card__quick-sizes');
    const trigger = card?.querySelector('[data-quick-sizes-trigger]');
    if (!panel || !trigger) return;
    const moveKeyboardFocus = open && trigger.matches(':focus-visible');
    if (open) {
      const list = panel.querySelector('.product-card__quick-sizes-list');
      arrange(list, Array.from(list.querySelectorAll('.product-card__size-button')));
      panel.querySelectorAll('[aria-busy]').forEach((button) => button.removeAttribute('aria-busy'));
    }
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    card.classList.toggle('is-sizing', open);
    if (moveKeyboardFocus) panel.querySelector('.product-card__size-button:not(:disabled)')?.focus({ preventScroll: true });
  }
  function closeAll(except) {
    document.querySelectorAll('.product-card.is-sizing').forEach((card) => { if (card !== except) setOpen(card, false); });
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-quick-sizes-trigger]');
    if (trigger) {
      event.preventDefault();
      const card = trigger.closest('product-card');
      closeAll(card);
      setOpen(card, !card.classList.contains('is-sizing'));
      return;
    }
    const button = event.target.closest?.('.product-card__size-button');
    if (button) {
      const form = button.closest('form');
      if (form?.elements.id && button.dataset.variantId) form.elements.id.value = button.dataset.variantId;
      return;
    }
    if (event.target.closest?.('.product-card__quick-sizes')) return;
    closeAll();
  });
  document.addEventListener('variant:add', () => closeAll());
  document.addEventListener('mr:card-color-change', () => closeAll());
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const card = document.querySelector('.product-card.is-sizing');
    const focused = card?.contains(document.activeElement);
    closeAll();
    if (focused) card.querySelector('[data-quick-sizes-trigger]').focus({ preventScroll: true });
  });
})();
